export default __webpack_public_path__ + "static/media/Paws_up.853ec0df.jpg";